// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-circle-3"},"children":[{"tag":"circle","attrs":{"id":"fill1","cx":12,"cy":12,"r":10,"fill":"props.fillColor1"}},{"tag":"circle","attrs":{"id":"stroke1","cx":12,"cy":12,"r":10,"stroke":"props.strokeColor1","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9.32353 7.5H15.0882V8.57143L10.9706 11.0714V11.7857H12.2059C14.0252 11.7857 15.5 13.0649 15.5 14.6429C15.5 16.2208 14.0252 17.5 12.2059 17.5H11.7941C9.97483 17.5 8.5 16.2208 8.5 14.6429","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const NumbersCircle3Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-circle-3',
    ref,
    icon: element,
  },
));

NumbersCircle3Icon.displayName = 'NumbersCircle3Icon';

export default NumbersCircle3Icon;
